<yat-payment-method-selection-common id="503af4d0-11e5-4e66-8a9e-a3c083752ff7"
  [paymentMethods]="(paymentMethods$ | async) ?? []"
  [selectedPaymentMethod]="selectedPaymentMethod$ | async"
  (saveSelection)="saveSelectedPaymentMethod($event)"
  (deleteMethod)="deletePaymentMethod($event)">
</yat-payment-method-selection-common>
